require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
//require("channels")

import "@stimulus/polyfills"

require("jquery")
require("jquery-paginate")
require("@nathanvda/cocoon")

import "controllers"
